export default __webpack_public_path__ + "6d9b37c7c687830182e2dc4357fdb343.svg";